import { create } from 'zustand';
import type { ChatState, Message } from '@/types';

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  isLoading: false,
  isSpeaking: false,
  error: null,

  addMessage: (text: string, sender: 'user' | 'ai', isError = false, isTyping = false) => {
    const message: Message = {
      id: `${Date.now()}-${Math.random()}`,
      text,
      sender,
      timestamp: new Date(),
      isError,
      isTyping,
    };
    set((state) => ({ messages: [...state.messages, message] }));
    return message.id;
  },

  updateMessage: (id: string, text: string, isTyping = false) => {
    set((state) => ({
      messages: state.messages.map((msg) => (msg.id === id ? { ...msg, text, isTyping } : msg)),
    }));
  },

  setLoading: (isLoading: boolean) => set({ isLoading }),

  setSpeaking: (isSpeaking: boolean) => set({ isSpeaking }),

  setError: (error: string | null) => set({ error }),

  clearMessages: () => set({ messages: [], error: null }),

  editMessage: (messageId: string, newText: string) => {
    set((state) => {
      const messageIndex = state.messages.findIndex((msg) => msg.id === messageId);
      if (messageIndex === -1) return state;

      // Remove all messages after the edited message (including AI response)
      const updatedMessages = state.messages.slice(0, messageIndex);
      // Update the message text
      updatedMessages.push({
        ...state.messages[messageIndex],
        text: newText,
      });

      return { messages: updatedMessages };
    });
  },
}));
